/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { logger as log } from '@common/logger';
import { HolderDetailPageService } from '@pages/HoldersDetailPage/services';

const getSrv = () => {
  return vappContainer.get<HolderDetailPageService>(
    HolderDetailPageService.displayName
  );
};

export const updateKyc = async (context: any, event: any) => {
  const currentState = 'UPDATE_KYC';
  const method = 'updateKyc';

  // @ts-ignore
  return new Promise(async (resolve, reject) => {
    try {
      log.log('context: ', context, 'event: ', event);
      const srv = getSrv();
      const _getArgs = () => {
        let _args: any = {};
        if (event?.type === 'START') {
          _args = context['UPDATE_KYC'];
        }
        if (event?.type === 'TRIGGER_REFRESH') {
          _args = {
            offset: event?.offset,
            size: event?.size,
            where: event?.where ?? [],
          };
        }
        return _args;
      };
      const shelves = await srv.agent.getupdateKYCStatus();
      console.log('KYCshelves', shelves);
      if (shelves) {
        return resolve({
          key: 'UPDATE_KYC_SUCCESS',
          value: shelves,
        });
      } else {
        const msg = 'Page content not found';
        log.error(`error in ${method}, msg: ${msg}`);
        return reject({
          key: 'UPDATE_KYC_FAILED',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(`error in 123 ${method}, msg: ${err?.message}`);
      console.log('KYCerror1234', err);
      return reject({
        key: 'UPDATE_KYC_FAILED',
        value: err,
      });
    }
  });
};
